import { css } from 'lit';

export default css`
  .nile-slide-toggle {
    display: flex;
    align-items: center;
  }

  .nile-slide-toggle__switch {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 16px;
    line-height: 22px;
    margin-right: 10px;
  }

  .nile-slide-toggle__label {
    margin-left: 2px;
    font-size: 14px;
  }

  .nile-slide-toggle__switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .nile-slide-toggle__slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--nile-colors-neutral-500);
    transition: 0.4s;
    border-radius: 34px;
  }

  .nile-slide-toggle__slider:before {
    position: absolute;
    content: '';
    height: 12px;
    width: 12px;
    bottom: 2px;
    left: 2px;
    background-color: var(--nile-colors-white-base);
    transition: 0.4s;
    border-radius: 50%;
  }

  .nile-slide-toggle__switch input:checked + .nile-slide-toggle__slider {
    background-color: var(--nile-colors-primary-600);
  }

  .nile-slide-toggle__switch input:focus + .nile-slide-toggle__slider {
    box-shadow: 0 0 1px var(--nile-colors-primary-600);
  }

  .nile-slide-toggle__switch input:checked + .nile-slide-toggle__slider:before {
    transform: translateX(16px);
  }

  .nile-slide-toggle__slider.round {
    border-radius: 20px;
  }

  .nile-slide-toggle__slider.round:before {
    border-radius: 50%;
  }
`;
